import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input"];

  select() {
    this.inputTarget.checked = true;
  }
}
